import React, { useEffect, useState } from "react";
import "./Hero.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

import ContactForm from "../../Components/ContactForm";

import img1 from "../../Asset/Images/f2.jpeg";
import img2 from "../../Asset/Images/f3.jpeg";
import img3 from "../../Asset/Images/Modal2.jpeg";

const images = [img1, img2, img3];

const Hero = () => {
  const { t } = useTranslation();
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-out-cubic",
      once: true,
    });
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section className="hero">
      {/* Background */}
      <div className="hero-bg">
        {images.map((img, index) => (
          <img
            key={index}
            src={img}
            alt="Elder care support"
            className={index === current ? "active" : ""}
          />
        ))}
      </div>

      <div className="hero-overlay"></div>

      <div className="hero-container">
        {/* LEFT */}
        <div className="hero-content" data-aos="fade-right">
          <h1>
            {t("hero_title1")} <span>{t("hero_title2")}</span>{" "}
            {t("hero_title3")} <span>{t("hero_title4")}</span>
          </h1>

          <p>{t("hero_description")}</p>

          <div className="hero-buttons" data-aos="fade-up" data-aos-delay="200">
            <NavLink to="/Donate">
              <button className="btn-primary">
                {t("hero_donate")}
              </button>
            </NavLink>

            <NavLink to="/Contactus">
              <button className="btn-outline">
                {t("hero_contact")}
              </button>
            </NavLink>
          </div>
        </div>

        {/* CONTACT FORM */}
        <div className="hero-form" data-aos="fade-left">
          <h3>{t("hero_form_title")}</h3>
          {/* Passing 't' to the form if it handles internal translations */}
          <ContactForm showTitle={false} />
        </div>
      </div>

      {/* STATS */}
      <div className="hero-stats">
        <div className="stat-card" data-aos="fade-up">
          <h2>8+</h2>
          <p>{t("hero_years")}</p>
        </div>

        <div className="stat-card" data-aos="fade-up" data-aos-delay="150">
          <h2>28+</h2>
          <p>{t("hero_seniors")}</p>
        </div>

        <div className="stat-card" data-aos="fade-up" data-aos-delay="300">
          <h2>100+</h2>
          <p>{t("hero_caregivers")}</p>
        </div>

        <div className="stat-card" data-aos="fade-up" data-aos-delay="450">
          <h2>99%</h2>
          <p>{t("hero_trusted")}</p>
        </div>
      </div>

      <svg
        className="hero-shape hero-shape-bottom"
        viewBox="0 0 1440 80"
        preserveAspectRatio="none"
      >
        <path
          d="M0,40 C240,50 480,30 720,38 960,45 1200,35 1440,42 L1440,80 L0,80 Z"
          fill="transparent"
        />
      </svg>
    </section>
  );
};

export default Hero;